import { getAuthorization } from 'controllers/controller';
import { DateTime } from 'luxon';
import { getJobTalentCountsService } from 'services/dashboard/getJobTalentCounts';

export const getjobTalentCounts = async (jobId, last, talentStatus) => {
  const authorization = getAuthorization();

  const { data } = await getJobTalentCountsService(authorization, {
    jobId,
    last,
    talentStatus,
  });

  return data.response.resultMap.Date;
};

export const formatTalentCountForApplicantsDashboard = (data) => {
  return data.map(({ count, field }) => ({
    y: count,
    name: DateTime.fromFormat(field, 'd-m-yyyy').toFormat('dd LLL'),
  }));
};
